import { Component, Input } from '@angular/core';
import { DnBtnSize } from '../dn-primary-btn/dn-primary-btn.config';
import { elemShow } from '../../constants/animations';

@Component({
  selector: 'dn-loader',
  templateUrl: './dn-loader.component.html',
  styleUrl: './dn-loader.component.scss',
  animations: [elemShow],
  standalone: false,
})
export class DnLoaderComponent {
  @Input() loaderSize: DnBtnSize;
  @Input() isInPrimary = true;
}
